import {faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'

interface HiltonPointsBannerProps {
  className?: string
  hiltonBookingPointsMessage?: string
  hiltonBookingUrl?: string
}

const DEFAULT_HILTON_POINTS_MESSAGE = 'Earn points when you book directly.'
const DEFAULT_HILTON_BOOKING_URL = 'https://www.hilton.com'

const HiltonPointsBanner: React.FC<HiltonPointsBannerProps> = ({
  className,
  hiltonBookingPointsMessage,
  hiltonBookingUrl
}) => {
  const message = hiltonBookingPointsMessage || DEFAULT_HILTON_POINTS_MESSAGE
  const url = hiltonBookingUrl || DEFAULT_HILTON_BOOKING_URL
  return (
    <div
      className={clsx(
        'py-2 bg-gray-200 rounded-lg font-medium text-center text-sm md:text-md',
        className
      )}
    >
      {message}{' '}
      <a className="link link-accent" href={url} target="_blank">
        Hilton
        <FontAwesomeIcon
          className="text-sm no-underline ml-1"
          icon={faArrowUpRightFromSquare}
        />
      </a>
    </div>
  )
}

export default HiltonPointsBanner
